<template>
  <div ref="box">
    
    <div class="header-box">
      <span class="set-box" v-if="!elementSetting.selectedTablePrintElement">
        <el-tooltip
          effect="dark"
          content="撤销"
          placement="bottom"
          :style="{ color: printHistory.historys.length > 1 ? '#000' : '#999' }"
        >
          <i class="iconfont icon-undo" @click="$bus.$emit('undo')"></i>
        </el-tooltip>
        <el-tooltip
          effect="dark"
          content="恢复"
          placement="bottom"
          :style="{ color: printHistory.historys2.length ? '#000' : '#999' }"
        >
          <i class="iconfont icon-redo" @click="$bus.$emit('redo')"></i>
        </el-tooltip>
        <el-select
          :value="
            elementSetting?.selectedBasePrintElement?.options?.fontSize ||
            font.fontSize
          "
          size="mini"
          style="
            width: 80px;
            font-size: 14px;
            margin: 0 2px 0 10px;
            vertical-align: middle;
          "
          :disabled="!elementSetting.selectedBasePrintElement"
          @change="changeFontSize"
          ><el-option
            v-for="item in [
              7.5, 9, 9.75, 10.5, 11.25, 12, 13.5, 15, 16.5, 18, 19.5, 21, 22.5,
              24,
            ]"
            :key="item"
            :label="item"
            :value="item"
          ></el-option
        ></el-select>
        <el-select
          :value="
            elementSetting?.selectedBasePrintElement?.options?.fontFamily ||
            font.fontFamily
          "
          size="mini"
          style="
            width: 149px;
            font-size: 14px;
            margin: 0 10px;
            vertical-align: middle;
          "
          :disabled="!elementSetting.selectedBasePrintElement"
          @change="changeFontFamily"
        >
          <el-option
            v-for="item in fontFamily"
            :key="item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
        <el-tooltip effect="dark" content="加粗" placement="bottom">
          <el-button
            class="iconfont icon-blod"
            :class="{
              active:
                elementSetting.selectedBasePrintElement &&
                elementSetting.selectedBasePrintElement.options.fontWeight ==
                  'bold',
            }"
            @click="
              changeFontWeight(
                elementSetting.selectedBasePrintElement.options.fontWeight
              )
            "
            :disabled="!elementSetting.selectedBasePrintElement"
          ></el-button>
        </el-tooltip>
        <el-tooltip effect="dark" content="下划线" placement="bottom">
          <el-button
            class="iconfont icon-underline"
            :class="{
              active:
                elementSetting.selectedBasePrintElement &&
                elementSetting.selectedBasePrintElement.options
                  .textDecoration == 'underline',
            }"
            @click="
              changeTextDecoration(
                elementSetting.selectedBasePrintElement.options.textDecoration
              )
            "
            :disabled="!elementSetting.selectedBasePrintElement"
          ></el-button>
        </el-tooltip>
        <el-tooltip effect="dark" content="倾斜" placement="bottom">
          <el-button
            class="iconfont icon-italic"
            :class="{
              active:
                elementSetting.selectedBasePrintElement &&
                elementSetting.selectedBasePrintElement.options.fontStyle ==
                  'italic',
            }"
            @click="
              changeFontStyle(
                elementSetting.selectedBasePrintElement.options.fontStyle
              )
            "
            :disabled="!elementSetting.selectedBasePrintElement"
          ></el-button>
        </el-tooltip>

        <span class="line"></span>
        <el-tooltip effect="dark" content="居左" placement="bottom">
          <el-button
            class="iconfont icon-align-left"
            :class="{
              active:
                elementSetting.selectedBasePrintElement &&
                (elementSetting.selectedBasePrintElement.options.textAlign ==
                  'left' ||
                  elementSetting.selectedBasePrintElement.options.textAlign ==
                    ''),
            }"
            @click="changeTextAlign('left')"
            :disabled="!elementSetting.selectedBasePrintElement"
          ></el-button>
        </el-tooltip>
        <el-tooltip effect="dark" content="居中" placement="bottom">
          <el-button
            class="iconfont icon-align-center"
            :class="{
              active:
                elementSetting.selectedBasePrintElement &&
                elementSetting.selectedBasePrintElement.options.textAlign ==
                  'center',
            }"
            @click="changeTextAlign('center')"
            :disabled="!elementSetting.selectedBasePrintElement"
          ></el-button>
        </el-tooltip>
        <el-tooltip effect="dark" content="居右" placement="bottom">
          <el-button
            class="iconfont icon-align-right"
            :class="{
              active:
                elementSetting.selectedBasePrintElement &&
                elementSetting.selectedBasePrintElement.options.textAlign ==
                  'right',
            }"
            @click="changeTextAlign('right')"
            :disabled="!elementSetting.selectedBasePrintElement"
          ></el-button>
        </el-tooltip>

        <span
          class="line"
          v-if="
            elementSetting?.selectedBasePrintElement?.printElementType?.type !=
            'longText'
          "
        ></span>
        <el-tooltip
          effect="dark"
          content="位于顶部"
          placement="bottom"
          v-if="
            elementSetting?.selectedBasePrintElement?.printElementType?.type !=
            'longText'
          "
        >
          <el-button
            class="iconfont icon-align-top"
            :class="{
              active:
                elementSetting.selectedBasePrintElement &&
                (elementSetting.selectedBasePrintElement.options
                  .textContentVerticalAlign == 'top' ||
                  elementSetting.selectedBasePrintElement.options
                    .textContentVerticalAlign == ''),
            }"
            @click="changeTextContentVerticalAlign('')"
            :disabled="!elementSetting.selectedBasePrintElement"
          ></el-button>
        </el-tooltip>
        <el-tooltip
          effect="dark"
          content="上下居中"
          placement="bottom"
          v-if="
            elementSetting?.selectedBasePrintElement?.printElementType?.type !=
            'longText'
          "
        >
          <el-button
            class="iconfont icon-align-center-center"
            :class="{
              active:
                elementSetting.selectedBasePrintElement &&
                elementSetting.selectedBasePrintElement.options
                  .textContentVerticalAlign == 'middle',
            }"
            @click="changeTextContentVerticalAlign('middle')"
            :disabled="!elementSetting.selectedBasePrintElement"
          ></el-button>
        </el-tooltip>
        <el-tooltip
          effect="dark"
          content="位于底部"
          placement="bottom"
          v-if="
            elementSetting?.selectedBasePrintElement?.printElementType?.type !=
            'longText'
          "
        >
          <el-button
            class="iconfont icon-align-bottom"
            :class="{
              active:
                elementSetting.selectedBasePrintElement &&
                elementSetting.selectedBasePrintElement.options
                  .textContentVerticalAlign == 'bottom',
            }"
            @click="changeTextContentVerticalAlign('bottom')"
            :disabled="!elementSetting.selectedBasePrintElement"
          ></el-button>
        </el-tooltip>
      </span>
      <span class="set-box" v-else>
        <el-tooltip
          effect="dark"
          content="撤销"
          placement="bottom"
          :style="{ color: printHistory.historys.length > 1 ? '#000' : '#999' }"
        >
          <i class="iconfont icon-undo" @click="$bus.$emit('undo')"></i>
        </el-tooltip>
        <el-tooltip
          effect="dark"
          content="恢复"
          placement="bottom"
          :style="{ color: printHistory.historys2.length ? '#000' : '#999' }"
        >
          <i class="iconfont icon-redo" @click="$bus.$emit('redo')"></i>
        </el-tooltip>
        <el-select
          :value="
            elementSetting?.selectedTablePrintElement?.options?.fontSize ||
            font.fontSize
          "
          size="mini"
          style="
            width: 80px;
            font-size: 14px;
            margin: 0 2px 0 10px;
            vertical-align: middle;
          "
          :disabled="!elementSetting.selectedTablePrintElement"
          @change="changeFontSize"
          ><el-option 
            v-for="item in [
              7.5, 9, 9.75, 10.5, 11.25, 12, 13.5, 15, 16.5, 18, 19.5, 21, 22.5,
              24,
            ]"
            :key="item"
            :label="item"
            :value="item"
          ></el-option
        ></el-select>
        <el-select
          :value="
            elementSetting?.selectedTablePrintElement?.options?.fontFamily
          "
          size="mini"
          style="
            width: 149px;
            font-size: 14px;
            margin: 0 10px;
            vertical-align: middle;
          "
          @change="changeFontFamily"
        >
          <el-option
            v-for="item in fontFamily"
            :key="item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
        <!-- <el-tooltip effect="dark" content="加粗" placement="bottom">
          <el-button
            class="iconfont icon-blod"
            :class="{
              active:
                elementSetting.selectedTablePrintElement.options.tableHeaderFontWeight ==
                  'bold',
            }"
            @click="
              changeOption(
                'tableHeaderFontWeight',
                elementSetting.selectedTablePrintElement.options.tableHeaderFontWeight=='bold'?'normal':'bold'
              )
            "
          
          ></el-button>
        </el-tooltip> -->
        <span class="line"></span>
        <el-tooltip effect="dark" content="居左" placement="bottom">
          <el-button
            class="iconfont icon-align-left"
            :class="{
              active:
                elementSetting.selectedTablePrintElement &&
                (elementSetting.selectedTablePrintElement.options.textAlign ==
                  'left' ||
                  elementSetting.selectedTablePrintElement.options.textAlign ==
                    ''),
            }"
            @click="changeTextAlign('left')"
          ></el-button>
        </el-tooltip>
        <el-tooltip effect="dark" content="居中" placement="bottom">
          <el-button
            class="iconfont icon-align-center"
            :class="{
              active:
                elementSetting.selectedTablePrintElement &&
                elementSetting.selectedTablePrintElement.options.textAlign ==
                  'center',
            }"
            @click="changeTextAlign('center')"
          ></el-button>
        </el-tooltip>
        <el-tooltip effect="dark" content="居右" placement="bottom">
          <el-button
            class="iconfont icon-align-right"
            :class="{
              active:
                elementSetting.selectedTablePrintElement &&
                elementSetting.selectedTablePrintElement.options.textAlign ==
                  'right',
            }"
            @click="changeTextAlign('right')"
          ></el-button>
        </el-tooltip>
      </span>
      <div class="fr " style="padding: 10px 0">
        
        <el-button size="mini" @click="handleExport">导出</el-button>
        <el-button size="mini" @click="handleImportClick">导入</el-button>
        <el-button type="primary" size="mini" @click="save">保存</el-button>
      </div>
      
    </div>
  </div>
</template>
<script>


export default {
  name: "PrintHeader",
  data() {
    return {
      font: {
        fontSize: 9,
        fontFamily: "微软雅黑",
        fontWeight: 400,
        textDecoration: "none",
        fontStyle: "normal",
      },
      align: {
        textAlign: "left",
        textContentVerticalAlign: "top",
      },
      fontFamily: ["宋体", "微软雅黑", "楷体", "幼圆", "Times New Roman"],
      elementSetting: elementSetting,
      printHistory: printHistory,
    };
  },
  methods: {
    async save() {
      // let res = updateTemplateContentById({
      //   content: JSON.stringify(this.printHistory.historys[0]),
      //   id: this.$store.getters.templateId,
      // });
      // console.log(res);
      this.$bus.$emit("save");
    },
    changeOption(attr, val) {
      if (elementSetting.selectedTablePrintElement) {
        elementSetting.selectedTablePrintElement.options[attr] = val;
        if (attr == "fontSize"){
          elementSetting.selectedTablePrintElement.options["lineHeight"] = val;
        }
        elementSetting.selectedTablePrintElement.updateDesignViewFromOptions();
      } else {
        if (
          attr == "fontSize" &&
          elementSetting.selectedBasePrintElement.options["height"] ==
            elementSetting.selectedBasePrintElement.options[attr]
        ) {
          elementSetting.selectedBasePrintElement.options["height"] = val;
          elementSetting.selectedBasePrintElement.updateSizeAndPositionOptions();
        }
        elementSetting.selectedBasePrintElement.options[attr] = val;
        elementSetting.selectedBasePrintElement.updateDesignViewFromOptions();
        this.$bus.$emit("design");
      }
    },
    changeFontFamily(val) {
      this.font.fontFamily = val;
      this.changeOption("fontFamily", val);
    },
    changeFontSize(val) {
      //不是数则设为9

      this.font.fontSize = val;

      this.changeOption("fontSize", val);
    },

    changeFontWeight(fontWeight) {
      if (fontWeight == "bold") {
        this.changeOption("fontWeight", "normal");
      } else if (fontWeight == "normal") {
        this.changeOption("fontWeight", "bold");
      } else {
        this.changeOption("fontWeight", "bold");
      }
    },
    changeTextDecoration(textDecoration) {
      if (textDecoration == "underline") {
        this.changeOption("textDecoration", "none");
      } else if (textDecoration == "none") {
        this.changeOption("textDecoration", "underline");
      } else {
        this.changeOption("textDecoration", "underline");
      }
    },
    changeFontStyle(fontStyle) {
      if (fontStyle == "italic") {
        this.changeOption("fontStyle", "normal");
      } else if (fontStyle == "normal") {
        this.changeOption("fontStyle", "italic");
      } else {
        this.changeOption("fontStyle", "italic");
      }
    },
    changeTextAlign(textAlign) {
      this.changeOption("textAlign", textAlign);
    },
    changeTextContentVerticalAlign(textContentVerticalAlign) {
      if (
        this.elementSetting.selectedBasePrintElement.options
          .textContentVerticalAlign == "bottom"
      ) {
        this.changeOption("textContentVerticalAlign", "");
        this.changeOption("textContentVerticalAlign", textContentVerticalAlign);
      } else {
        this.changeOption("textContentVerticalAlign", textContentVerticalAlign);
      }
    },
    handleExport() {
      this.$bus.$emit("handleExport");
    },
    handleImportClick() {

      this.$bus.$emit("handleImportClick");
      
    },

  },
  mounted() {
    this.$refs.box.addEventListener("click", (e) => {
      //阻止冒泡
      e.stopPropagation();
      //阻止默认行为
      e.preventDefault();
    });
  },
};
</script>
<style lang="less" scoped>
.fr {
  float: right;
  margin-top: -10px;
}
.set-box {
  /* 字体无法选中 */
  user-select: none;

  font: 14px "微软雅黑";

  .iconfont {
    padding: 0;
    display: inline-block;
    width: 28px;
    height: 25px;
    line-height: 25px;
    vertical-align: middle;
    border-radius: 3px;
    margin: 0 1px;
    &.active {
      background: #409eff;
      color: #fff;
    }
  }
  .line {
    display: inline-block;
    width: 2px;
    height: 18px;
    background: #eee;
    vertical-align: middle;
    margin: 0 10px;
  }
}
.header-box {
  padding: 10px;
  text-align: center;
}
.icon-undo,
.icon-redo {
  &:hover {
    background: #eee;
  }
}
</style>